<template>
  <layout name="LayoutDefault">
    <!-- Page Content -->
    <div class="container">
      <div v-if="!bannerLoading && banner.length > 0" class="row slider">
        <div class="col-md-12">
          <div
            id="sliderCarousel"
            class="carousel slide bg-white home-banner"
            data-ride="carousel"
          >
            <ol class="carousel-indicators">
              <li
                data-target="#sliderCarousel"
                v-for="(item, index) in banner"
                v-bind:class="{ active: index === 0 }"
                :data-slide-to="`${index}`"
                v-bind:key="index"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div
                v-bind:key="index"
                v-for="(item, index) in banner"
                v-bind:class="{ 'carousel-item': true, active: index === 0 }"
              >
                <a :href="`${item.short_description || '#'}`">
                  <vue-load-image>
                    <img
                      slot="image"
                      v-bind:src="`${IMAGEURL}${item.image}`"
                      alt="Image"
                      style="max-width: 100%"
                    />
                    <img
                      slot="preloader"
                      v-bind:src="`${IMAGEURL}/assets/img/loader.gif`"
                      title="Image Loading..."
                    />
                    <div slot="error">can't load image</div>
                  </vue-load-image>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="body-section">
        <Loader :isEnable="sectionLoading" :title="`Loading Items`"></Loader>

        <div
          v-for="(section, skey) in sectionProducts"
          v-bind:key="skey"
          class="row mb-4"
        >
          <div class="col-lg-12">
            <div class="section-column">
              <div class="section-header d-flex justify-content-between">
                <h2>
                  {{ section.title }}
                </h2>
                <div>
                  <a
                    :href="`${baseUrl}section/${section.id}`"
                    class="more-link float-right mt-2 position-relative"
                    >আরো দেখুন <i class="fa fa-caret-right"></i
                  ></a>
                </div>
              </div>

              <div class="section-items">
                <div class="row">
                  <div
                    v-for="(item, k) in section.products"
                    v-bind:key="k"
                    class="col-lg-2 col-sm-6 col-6"
                  >
                    <BookCard
                      :item="item"
                      btn-class="btn-sm"
                      @add-to-cart="addToCart"
                    />
                  </div>
                </div>
              </div>

              <div v-if="!sectionLoading && sectionProducts.length < 1">
                Sorry but no product found.
              </div>
            </div>
          </div>
        </div>

        <div v-if="homeAd" class="row mb-5 home-footer-ad">
          <div
            v-for="(item, k) in homeAd"
            v-bind:key="k"
            class="col-12 col-sm-6 mt-3 mt-lg-0"
          >
            <a :href="`${item.short_description}`">
              <img
                v-bind:src="`${IMAGEURL}${item.image}`"
                alt=""
                class="w-100 rounded"
              />
            </a>
          </div>
        </div>
      </div>

      <!---------------------popup----------------->

      <!-- Modal -->
      <div
        class="modal fade modal-center"
        id="myModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" style="border: 0px">
            <button
              class="close"
              data-dismiss="modal"
              style="
                position: absolute;
                right: 0;
                z-index: 4;
                border: 1px solid #aa4242;
                padding: 0px 8px;
                background: #aa4242;
                color: #fff;
              "
            >
              &times;
            </button>

            <div class="modal-body" style="padding: 0px">
              <div v-if="popup">
                <a
                  :href="`${popup.short_description}`"
                  v-if="popup.short_description"
                >
                  <img
                    v-bind:src="`${IMAGEURL}${popup.image}`"
                    alt="Image"
                    class="img-responsive"
                /></a>
                <img
                  v-else
                  v-bind:src="`${IMAGEURL}${popup.image}`"
                  alt="Image"
                  class="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import Loader from "./common/Loader.vue";
import BookCard from "../components/BookCard.vue";

export default {
  name: `Home`,
  data() {
    return {
      sectionProducts: [],
      banner: [],
      popup: null,
      homeAd: null,
      sectionLoading: true,
      bannerLoading: true,
    };
  },
  components: {
    Loader,
    Layout,
    BookCard,
    "vue-load-image": VueLoadImage,
  },
  methods: {
    addToCart(row) {
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name,
      };
      this.$helper.saveToCart(itemObj);
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
      this.flashMessage.success({ message: "Added item to cart" });
    },
    async getHomeSections() {
      try {
        const response = await this.$http.get("home-sections");
        this.sectionProducts = response.data;
      } catch (error) {
        this.sectionProducts = [];
      }
      this.sectionLoading = false;
    },
    async getBanner() {
      try {
        const response = await this.$http.get("cms-resources/Banner-Slider");
        this.banner = response.data.data;
      } catch (error) {
        this.banner = [];
      }
      this.bannerLoading = false;
      if (this.banner.length > 0) {
        this.$nextTick(() => {
          $("#sliderCarousel").carousel({ interval: 4000 });
        });
      }
    },
    async getPopUp() {
      try {
        const response = await this.$http.get("cms-resources/Pop-Up");
        this.popup = response.data.data[0];
        if (this.popup.status == "Active") {
          $("#myModal").modal("show");
        }
      } catch (error) {
        this.popup = null;
      }
    },
    async getAd() {
      try {
        const response = await this.$http.get("cms-resources/Home-Ad");
        this.homeAd = response.data.data;
      } catch (error) {
        this.homeAd = null;
      }
    },
  },
  mounted() {
    this.getPopUp();
    this.getHomeSections();
    this.getBanner();
    this.getAd();
  },
};
</script>
